import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import close icon
import { useNotification } from '../../hooks/useNotification';
import { paymentRequestMarkAsReject } from '../../api/paymentRequestApi';

const RejectPaymentModal = ({ id, open, onClose, refetch }) => {
  const [reason, setReason] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const { showErrorNotification, showSuccessNotification } = useNotification()

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleMarkAsReject = () => {
    if (id) {
      paymentRequestMarkAsReject({ transactionId: id, setSaving,rejectReason:reason })
        .then(result => {
          showSuccessNotification(result?.message || "Marked as rejected")
          refetch && refetch()
          onClose()
        })
        .catch(error => {
          showErrorNotification(error?.message)
        }).finally(res=>{
           setReason('');
        })
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 'bold',
          fontSize: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography sx={{ fontWeight: 'bold', fontSize: '20px' }}>
          Reject Payment Request
        </Typography>

        {/* Close Icon Button */}
        <IconButton onClick={handleClose} sx={{ color: '#999' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box mb={2}>
          <Typography sx={{ mb: 1, fontSize: '14px', fontWeight: '600' }}>
            Reason for Rejection
          </Typography>
          <TextField
            multiline
            rows={4}
            fullWidth
            placeholder="Add comments for rejection"
            variant="outlined"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            sx={{
              "& .MuiInputBase-root": {
                fontSize: '14px',
              },
              "& .MuiInputBase-input::placeholder": {
                fontSize: "14px !important",
                color: "#6E7485",
              },
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button disabled={saving} fullWidth onClick={handleClose} sx={{
          border: '1px solid rgba(73, 95, 110, 0.20)', color: '#363853', textTransform: 'capitalize', px: 3,
        }}>
          Cancel
        </Button>
        <Button
          fullWidth
          onClick={handleMarkAsReject}
          loading={saving}
          sx={{
            backgroundColor: '#1075FF',
            color: '#fff',
            textTransform: 'capitalize',
            px: 3,
            '&:hover': { backgroundColor: '#1075FF' },

            // Disabled state styling
            '&.Mui-disabled': {
              backgroundColor: '#d0e4ffff',
              color: '#ffffff',
              opacity: 1,
            },
          }}
          disabled={!reason.trim() || saving}
        >
          Confirm Rejection
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default RejectPaymentModal;
